
import { defineComponent, nextTick } from 'vue';
import PrzVideo from '@/components/Muffin/Video/Component.vue';

export default defineComponent({
    components:{
        PrzVideo
    },
    props: {
        source: {
            type: String,
            default: undefined
        },
        poster: {
            type: String,
            default: undefined
        },
        className:{
            type: [String, Object],
            default: undefined
        },
        inViewport: {
            type: Boolean,
            default: false
        },
        autoplay: {
            type: Boolean,
            default: true
        }
    },
    data(){
        let videoDom: any = null;
        let showVideo = false;
        return {
            videoDom,
            showVideo
        }
    },
    mounted(){
        this.showVideo = this.inViewport;
    },
    methods:{
        onplay(player: any){
            this.$emit('onplay', player);
        }
    },
    watch:{
        //Reuse the video, on save the HTMLElement and append to the DOM
        async inViewport(newValue){

            //if in viewport and videoDOM not saved yet: save the videoDOM
            if(!newValue && !this.videoDom){
                let el: HTMLElement|null = this.$el?.querySelector('.prz-blk-bg-video') ?? null;
                if(el){
                    this.videoDom = el;
                }
            }

            this.showVideo = newValue;

            //waiting DOM updated 
            await nextTick();

            //if in viewport and videoDOM is saved: play the video saved
            if(newValue && this.videoDom){
                let el = this.$el?.querySelector('.prz-blk-bg-video-replay');
                if(el){
                    if(this.videoDom){
                        try{
                            let v: HTMLVideoElement|null = this.videoDom.querySelector('video');
                            if(v){
                                v.muted = true;
                                await v.play();
                            }
                        }catch(e){}
                    }
                    el.appendChild(this.videoDom);
                }
            }

            //if leave viewport and videoDOM is saved: Stop video
            if(!newValue && this.videoDom){
                try{
                    let v: HTMLVideoElement|null = this.videoDom.querySelector('video');
                    if(v){
                        v.loop = true;
                        //v.setAttribute('loop','true');
                        v.pause();
                    }
                }catch(e){}
            }
        }
    }
});
